export default __webpack_public_path__ + "d3c5fd29759a987b76f162c7225143f4.svg";